import {Component, OnInit, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {ItemsGroup} from '../itemsGroups';
import {ItemsGroupService} from '../itemsGroups.service';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message, SelectItem} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {TreeNode} from 'primeng/api';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, DropdownModule, MessagesModule} from "primeng/primeng";
import {Http} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {TreeModule} from "primeng/tree";
import {Item} from "../../items/items";
import {RecordDataComponent} from "../../../../components/record-data";
import {AppArcComponent} from "../../../../components/app-arc";
import {stringify} from "@angular/compiler/src/util";
import {YearsShowComponent} from "../../years/years-show/years-show.component";
import {BranchesShowComponent} from "../../branches/branches-show/branches-show.component";
import {TaxesShowComponent} from "../../taxes/taxes-show/taxes-show.component";
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";
import {RecieptVouchers} from "../../../fin/reciept_vouchers/reciept_vouchers";
import {appConfig} from '../../../../app.config';

@NgModule({
    imports: [CommonModule, FormsModule, TreeModule, DropdownModule,MessagesModule,MyInputsModule,
        ReactiveFormsModule, ConfirmDialogModule, TranslateModule.forChild()
    ],
    declarations: [
        ItemsGroupsShowComponent
    ],
    entryComponents: [
        ItemsGroupsShowComponent
    ],
    exports: [],
    providers: [SharedService, ItemsGroupService, MessageService, ConfirmationService],
    schemas: [NO_ERRORS_SCHEMA]
})

@Component({
    selector: 'app-itemsGroups-show',
    templateUrl: './itemsGroups-show.component.html',
    styleUrls: ['./itemsGroups-show.component.scss'],
    providers: [ItemsGroupService, ConfirmationService, MessageService]
})

export class ItemsGroupsShowComponent implements OnInit, AfterViewInit {
    id: string;
    itemsGroup = new ItemsGroup("", "","", '1','2', '1','1','1',"", "");
    applog: AppLogComponent;
    @Input() delId;
    @Input() scrId;
    @Input() oldData;
    @Input() newData;
    @Input() modelName;
    @Input() newDatad;
    @Input() newDatap;

    modalRef: NgbModalRef;
    parent:any;
    itemsGroupForm: FormGroup;
    group: any[] = [];
    tree: TreeNode[];
    item: Item;
    name: string;
    image: string;
    private sub: any;
    msgs: Message[] = [];
    alltaxs: any[] = [];
    taxs_enhance: any[] = [];

    Selectedtax: any;
    taxCount: any[] = [];
    deletedrow: any[] = [];
    selectedrow: any[] = [];

    restoreInv: any;
    Selected_taxs: any[] = [];
    Selected_taxs_old: any[] = [];
    taxs: SelectItem[] = [];
    Selected_taxs_db: string[] = [];
    selectedTaxs: string[] = [];
    public imgUrl = appConfig.publicUrl;

    vatVal = [{'val': 1, 'title': 'Yes', 'class': 'status-text float-right margin-btm p-5'},
        {'val': 2, 'title': 'No', 'class': 'status-text float-right margin-btm p-5'}];
    typeVal = [{'val': 1, 'title': 'Origin'}, {'val': 2, 'title': 'Services'}, {'val': 3, 'title': 'Consumables'}];
    statusVal = [{
        'val': 1,
        'title': 'Yes',
        'class': 'status-text label label-success btn-sm col-xs-4 margin-btm p-5'
    }, {'val': 2, 'title': 'No', 'class': 'status-text label label-danger btn-sm col-xs-4 margin-btm p-5'}];
    tax_classVal = [{'val': 1, 'title': 'stbr_tax'}, {'val': 2, 'title': 'sceh_tax'}, {'val': 3, 'title': 'stz_tax'}, {'val': 4, 'title': 'exem_tax'}];

    private _saveButton: any;
    private _deleteButton: any;
    private _newButton: any;
    private _printButton: any;
    private _searchButton: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private itemsGroupsService: ItemsGroupService,
                public activeModal: NgbActiveModal,
                public translate: TranslateService,
                private modalService: NgbModal,
                private confirmationService: ConfirmationService,
                private messageService: MessageService) {
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata && userdata.lang) {
            this.translate.use(userdata.lang);
        }
        this.sharedservice.setTitle(this.route.snapshot.data.title);
        this.sharedservice.setItemShow(ItemsGroupsShowComponent);
        this.sharedservice.setButtons([
            {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton'},
            {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton'},
            // {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton'},
            {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton'},
            {label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton'},


        ]);
        this.sharedservice.setModelName('itemsGroups');

    }
  showtax(id:any) {
    if(id) {
      const options: NgbModalOptions = {

        beforeDismiss: () => {
          console.log("before dismiss");
          //
          return true;
        }
      };
      this.modalRef = this.modalService.open(TaxesShowComponent , options);
      this.modalRef.componentInstance.scrId = id;
      console.log(this.parent);
      this.modalRef.result.then(() => {
        this.activeModal.dismiss('done');
      }, () => {
        console.log('Backdrop click')
      });
    }
  }
    showParent(){
        if(this.parent) {

            const options: NgbModalOptions = {

                beforeDismiss: () => {
                    console.log("before dismiss");
                    //
                    return true;
                }
            };
            this.modalRef = this.modalService.open(ItemsGroupsShowComponent, options);
            this.modalRef.componentInstance.scrId = this.parent;

            this.modalRef.result.then(() => {
                this.activeModal.dismiss('done');
            }, () => {
                console.log('Backdrop click')
            });
        }
    }
    recordData() {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                // this.changePicUrl();
                return true;
            }
        };
        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.itemsGroup;
        modalRef.componentInstance.rowId = '';

    }
    ngAfterViewInit() {
        if(!this.scrId && !this.oldData) {

            this._saveButton = document.getElementById('editButton');
            this._deleteButton = document.getElementById('deleteButton');
            this._newButton = document.getElementById('newButton');
            this._printButton = document.getElementById('printButton');
            this._searchButton = document.getElementById('searchButton');

            if (this._saveButton) {
                this._saveButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/itemsGroups/edit', this.id]);
                });
            }
            if (this._deleteButton) {
                this._deleteButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.deleteItemsGroup(this.itemsGroup);
                });
            }
            if (this._newButton) {

                this._newButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/itemsGroups']);
                });
            }
            if (this._searchButton) {
                this._searchButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/itemsGroups/search']);
                });
            }
        }
    }

    ngOnInit() {
      this.router.routeReuseStrategy.shouldReuseRoute = function(){
        return false;
      };

      this.router.events.subscribe((evt) => {
        if (evt instanceof NavigationEnd) {
          this.router.navigated = false;
          window.scrollTo(0, 0);
        }
      });

        this.itemsGroupsService.getAllGroups().subscribe(
            group => {
                this.group = group;
            });
        this.itemsGroupsService.getTree('0').then(tree => this.tree = tree);
        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
        });

        this.itemsGroupForm = new FormGroup({
            id: new FormControl({value: '', disabled: true}, Validators.required),
            name: new FormControl({value: '', disabled: true}, Validators.required),
            items_types: new FormControl({value: '', disabled: true}),
            computation_vat: new FormControl({value: '', disabled: true}, Validators.required),
            p_group_id: new FormControl({value: '', disabled: true}, Validators.required),
            status: new FormControl({value: '', disabled: true}, Validators.required),
            tax_class: new FormControl({value: '', disabled: true}),
            lewaq: new FormControl({value: '', disabled: true}),
            picture: new FormControl({value: '', disabled: true})

        });

        if (this.id) {
            this.activeModal.dismiss('');
            this.oldData = false;
            this.newData = false;
            this.newDatap = true;

            this.delId = false;
            localStorage.removeItem('filter');
            const msg = JSON.parse(localStorage.getItem('showMessages'));
            if (msg) {
                localStorage.removeItem('showMessages');
                this.msgs = msg;
                this.msgs = [];
            }
            this.itemsGroupsService.getById(this.id).subscribe(
                itemsGroup => {
                    this.id = itemsGroup.id;
                    this.itemsGroup = itemsGroup;
                    this.parent = itemsGroup.p_group_id;
                    this.itemsGroupForm.patchValue({
                        id: itemsGroup.id,
                        name: itemsGroup.name,
                        items_types: itemsGroup.items_types,
                        computation_vat: itemsGroup.computation_vat,
                        p_group_id: itemsGroup.p_group_id,
                        status: itemsGroup.status,
                        tax_class: itemsGroup.tax_class,
                        picture: itemsGroup.picture,
                        lewaq: itemsGroup.lewaq
                    });
                    this.image = itemsGroup.picture;
                    this.Selected_taxs= itemsGroup.allbranch2;
                }, error => {
                    console.log(error);
                }
            );


        }
        if (this.scrId) {
            this.oldData = false;
            this.newData = false;
            this.delId = false;
            this.itemsGroupsService.getById(this.scrId).subscribe(
                itemsGroup => {
                    this.id = itemsGroup.id;
                    this.itemsGroup = itemsGroup;
                    this.itemsGroupForm.patchValue({
                        id: itemsGroup.id,
                        name: itemsGroup.name,
                        items_types: itemsGroup.items_types,
                        computation_vat: itemsGroup.computation_vat,
                        p_group_id: itemsGroup.p_group_id,
                        status: itemsGroup.status,
                        tax_class: itemsGroup.tax_class,
                        picture: itemsGroup.picture,
                        lewaq: itemsGroup.lewaq
                    });
                    this.image = itemsGroup.picture;
                    this.Selected_taxs= itemsGroup.allbranch2;
                }, error => {
                    console.log(error);
                }
            );


        }
        if (this.delId) {
            this.oldData = false;
            this.newData = false;
            this.newDatap = !this.newDatap ;
            this.itemsGroupsService.getTrashedById(this.delId).subscribe(
                itemsGroup => {
                    this.id = itemsGroup.id;
                    this.itemsGroup = itemsGroup;
                    this.itemsGroupForm.patchValue({
                        id: itemsGroup.id,
                        name: itemsGroup.name,
                        items_types: itemsGroup.items_types,
                        computation_vat: itemsGroup.computation_vat,
                        p_group_id: itemsGroup.p_group_id,
                        status: itemsGroup.status,
                        tax_class: itemsGroup.tax_class,
                        picture: itemsGroup.picture,
                        lewaq: itemsGroup.lewaq
                    });
                }, error => {
                    console.log(error);
                }
            );
        }

        if (this.oldData && this.newData) {
            this.itemsGroup = this.newData.items_groups;

            this.Selected_taxs= this.newData.allbranch2;
            this.Selected_taxs_old= this.oldData.allbranch2;

            this.restoreInv = this.oldData.items_groups;
            this.restoreInv.taxs = JSON.stringify(this.oldData.allbranch2);
            
            this.itemsGroupForm.patchValue({
                id: this.newData.items_groups.id,
                name: this.newData.items_groups.name,
                items_types: this.newData.items_groups.items_types,
                computation_vat: this.newData.items_groups.computation_vat,
                p_group_id: this.newData.items_groups.p_group_id,
                status: this.newData.items_groups.status,
                tax_class: this.newData.items_groups.tax_class,
                picture: this.newData.items_groups.picture,
                lewaq: this.newData.items_groups.lewaq
            });
            console.log('this.oldData.items_groups');
            console.log(this.oldData.items_groups);
            console.log('this.itemsGroup');
            console.log(this.itemsGroup);
        }
    }
    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if(userRoles.indexOf('setting.items_groups.'+role) >= 0 || userRoles.indexOf('setting.itemsGroups.'+role) >= 0) {
            return true;
        }
        return false;
    }

    nodeSelect(_id: string) {
        this.itemsGroupsService.getById(_id).subscribe(
            itemsGroup => {

              this.router.navigate(['/itemsGroups/show', itemsGroup.id]);
                this.itemsGroup = itemsGroup;
                this.itemsGroupForm.patchValue({
                    id: itemsGroup.id,
                    name: itemsGroup.name,
                    items_types: itemsGroup.items_types,
                    computation_vat: itemsGroup.computation_vat,
                    p_group_id: itemsGroup.p_group_id,
                    status: itemsGroup.status,
                    tax_class: itemsGroup.tax_class,
                    lewaq: itemsGroup.lewaq
                });
            }, error => {
                console.log(error);
            }
        );
    }

    addnew(_id: string) {
        this.router.navigate(['/itemsGroups', _id]);
    }

    deleteItemsGroup(itemsGroup: ItemsGroup) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Delete'),
            message: this.translate.instant('Are you sure of delete ?'),
            icon: 'fa fa-trash',
            accept: () => {
                if (itemsGroup) {
                    this.itemsGroupsService.delete(itemsGroup.id).subscribe(
                        res => {
                            this.msgs = [];
                            console.log(res.result);
                            if(res.result){

                              this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant(res.message)
                              });
                            }else{

                              this.msgs.push({
                                severity: 'error',
                                summary: '',
                                detail: this.translate.instant(res.message)
                              });
                            }

                            setTimeout(()=> {
                                this.router.navigate(['/itemsGroups']);
                            },1000);
                            localStorage.setItem('showMessages', JSON.stringify(this.msgs));
                            window.scroll(0,0);
                        }
                    );
                }
            }
        });
    }

    recoverEdit(itemsGroup: ItemsGroup) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if (itemsGroup) {
                    this.itemsGroupsService.update(itemsGroup).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');
                            this.router.navigate(['/itemsGroups/show', itemsGroup.id]);
                        }
                    );
                }
            }
        });
    }

    undotrashed() {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if (this.delId) {
                    this.itemsGroupsService.restoreTrashedById(this.delId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted item recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/itemsGroups/list']);
                        }
                    );
                }
            }
        });
    }



  showattachement(row_id: string) {
    console.log(row_id)
    if (row_id) {
      const options: NgbModalOptions = {

        beforeDismiss: () => {
          // this.changePicUrl();
          return true;
        }
      };
      const modalRef = this.modalService.open(AppArcComponent, options);
      modalRef.componentInstance.rowId = row_id;
      modalRef.componentInstance.screenName = this.modelName;
    }
  }
  showHistory(row_id: string) {
    if (row_id) {
      const modalRef = this.modalService.open(AppLogComponent);
      modalRef.componentInstance.rowId = row_id;
        modalRef.componentInstance.refShow = ItemsGroupsShowComponent;

    }
  }





}



// WEBPACK FOOTER //
// ./src/app/views/setting/itemsGroups/itemsGroups-show/itemsGroups-show.component.ts